import useMounted from './useMounted';

export default useMounted;
